import script from "./RefreshWarn.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefreshWarn.vue?vue&type=script&setup=true&lang=ts"

import "./RefreshWarn.vue?vue&type=style&index=0&id=3cbe9593&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbe9593"]])

export default __exports__